/**
 * LBX - AddToProductAvailabilityList
 *
 * This script handles adding products to the product availability list,
 * allowing users to track product availability or manage their preferences.
 *
 */

import { connect } from 'react-redux';
import getStore from 'Util/Store';

import CustomerProductListQuery from 'Query/CustomerProductList.query';
import { fetchMutation, getErrorMessage } from 'Util/Request';
import { showNotification } from 'Store/Notification/Notification.action';

export const mapDispatchToProps = (dispatch) => ({
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    showErrorNotification: (error) => dispatch(showNotification('error', getErrorMessage(error)))
});

const _addToProductAvailabilityList = async (sku) => {
    const store = getStore();
    const state = store.getState();
    const { showNotification, showErrorNotification } = mapDispatchToProps(store.dispatch);
    const { lbx_add_to_availability_list_enabled } = state.ConfigReducer;

    if (String(lbx_add_to_availability_list_enabled) !== '1') return null;

    return fetchMutation(CustomerProductListQuery.getAddProductToListMutation({ sku: sku, parent_sku: sku }))
        .then((fulfilled) => {
            showNotification('success', __('Successfully added product to the list'));

            return fulfilled;
        })
        .catch((error) => {
            showErrorNotification(error);

            return error;
        });
}

window.AddToProductAvailabilityList = (sku) => _addToProductAvailabilityList(sku);

connect(null, mapDispatchToProps)(_addToProductAvailabilityList);
